import AddLocation from '@/components/add-location';

export default AddLocation;
